<div class="p-4 lg:p-10 flex-1 flex flex-col">
  <div class="hidden md:flex items-center justify-end gap-6"></div>
  <div class="welcome flex flex-col gap-6 py-6">
    <div class="font-efSans-secondary font-semibold uppercase">
      {{ 'customer-portal' | sharedTranslate }}
    </div>
    <div class="font-canelablack-primary text-4xl md:text-5xl">
      <T
        str="Confirm your mobile number"
        key="customerPortal.kc.enter-telephone.title"
        tags="kc-forms, 3.1"
      ></T>
    </div>
    <div
      class="text-mat-ef-revolution-primary-500 font-efSans text-xl font-light"
    >
      <T
        str="We ask you for additional details that will help us to provide a better and more personalized service"
        key="customerPortal.kc.enter-telephone.text"
        tags="kc-forms, 3.1"
      ></T>
    </div>
    <div
      class="text-mat-ef-revolution-primary-500 font-efSans text-xl font-light"
    >
      <T
        str="Additional details"
        key="customerPortal.kc.enter-telephone.subtitle"
        tags="kc-forms, 3.1"
      ></T>
    </div>
  </div>
  <div class="form-container">
    <form
      #enterTelephoneForm
      [formGroup]="form"
      method="POST"
      [action]="viewData.registrationAction"
      (ngSubmit)="submit()"
      class="grid"
    >
      <div class="grid grid-cols-3 gap-4">
        <mat-form-field class="col-span-3 md:col-span-1">
          <mat-label>
            {{ 'prefix' | sharedTranslate }}
          </mat-label>
          <mat-select class="ef-select" formControlName="mobilePrefix" required>
            <mat-option
              *ngFor="let mobilePrefix of mobilePrefixes | keyvalue"
              [value]="'+' + mobilePrefix.value"
              >+{{ mobilePrefix.value }}</mat-option
            >
          </mat-select>
          <mat-icon
            *ngIf="
              form.controls.mobilePrefix.touched &&
              form.controls.mobilePrefix.invalid
            "
            matSuffix
            color="error"
            svgIcon="error_outline"
          ></mat-icon>
        </mat-form-field>
        <mat-form-field class="col-span-3 md:col-span-2">
          <mat-label>
            {{ 'mobile-number' | sharedTranslate }}
          </mat-label>
          <input
            class="input"
            matInput
            type="tel"
            required
            formControlName="mobile"
            [maxLength]="remoteConfigService.get('phoneNumber.length')"
          />
          <mat-icon
            *ngIf="form.controls.mobile.touched && form.controls.mobile.invalid"
            matSuffix
            color="error"
            svgIcon="error_outline"
          ></mat-icon>
          <mat-error *ngIf="form.controls.mobile.invalid">
            {{
              transifexService.getErrorTranslation(
                form.controls.mobile,
                'customerPortal.kc.enter-telephone.mobile.error.'
              )
            }}
          </mat-error>
        </mat-form-field>
      </div>
      <div class="enter-telephone-button">
        <input type="hidden" name="step" value="enter_telephone" />
        <input type="hidden" name="telephoneNumber" [value]="telephone" />
        <button
          mat-button
          mat-raised-button
          color="secondary"
          type="submit"
          (click)="submit()"
          [disabled]="!form.valid || submitting"
          class="revolution w-full lg:w-1/2 button-spinner"
        >
          <customer-portal-ef-spinner
            [color]="'mat-ef-revolution-grey-two-500'"
            [opacity]="0.7"
            [diameter]="16"
            *ngIf="submitting"
          >
          </customer-portal-ef-spinner>
          <div>
            {{ 'next' | sharedTranslate }}
          </div>
        </button>
      </div>
    </form>
  </div>
</div>
